/* Thulir — shared faceted product-grid behaviour.
 *
 * Drives BOTH the collection page (sections/thulir-collection.liquid) and the
 * search results page (sections/thulir-search.liquid). Both render the shared
 * snippets/thulir-facet-grid.liquid markup, whose root carries:
 *     data-thulir-facet-grid   — init hook
 *     data-section-id          — for the Section Rendering API (?section_id=)
 *     data-base-url            — collection.url or routes.search_url
 *
 * Progressive enhancement: without JS the forms submit / links navigate
 * natively; here we upgrade sort / filter / pills / load-more to AJAX via the
 * Section Rendering API, swapping the [data-thulir-*] regions in place.
 */
(function () {
  var CLOSE_MS = 360;
  var grids = []; // { root, applyUrl } — so one popstate handler serves all

  function initFacetGrid(root) {
    if (root.__thulirFacetInit) return;
    root.__thulirFacetInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var baseUrl = root.getAttribute('data-base-url') || window.location.pathname;
    var drawer = root.querySelector('[data-thulir-drawer]');
    var sortSelect = root.querySelector('[data-thulir-sort]');
    var results = root.querySelector('[data-thulir-results]');

    function sectionUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function fetchDoc(url) {
      return fetch(sectionUrl(url), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    function setLoading(on) {
      if (results) results.classList.toggle('is-loading', !!on);
    }

    /* ---------- Two-sided price slider ---------- */
    function readInt(val, fallback) {
      var n = parseInt(String(val).replace(/[^0-9]/g, ''), 10);
      return isNaN(n) ? fallback : n;
    }
    function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
    function priceEls(price) {
      return {
        min: parseInt(price.getAttribute('data-min'), 10) || 0,
        max: parseInt(price.getAttribute('data-max'), 10) || 0,
        rMin: price.querySelector('[data-thulir-price-range="min"]'),
        rMax: price.querySelector('[data-thulir-price-range="max"]'),
        iMin: price.querySelector('[data-thulir-price-input="min"]'),
        iMax: price.querySelector('[data-thulir-price-input="max"]'),
        fill: price.querySelector('[data-thulir-price-fill]')
      };
    }
    function positionFill(e, minV, maxV) {
      var span = (e.max - e.min) || 1;
      var l = ((minV - e.min) / span) * 100;
      var r = ((maxV - e.min) / span) * 100;
      if (e.fill) { e.fill.style.left = l + '%'; e.fill.style.width = (r - l) + '%'; }
      /* Keep the lower thumb grabbable when both sit at the top. */
      if (e.rMin) e.rMin.style.zIndex = (minV >= maxV) ? 5 : 3;
    }
    /* A range thumb moved — enforce order, mirror into both text inputs. */
    function onPriceRange(price, which) {
      var e = priceEls(price);
      if (!e.rMin || !e.rMax) return;
      var minV = clamp(readInt(e.rMin.value, e.min), e.min, e.max);
      var maxV = clamp(readInt(e.rMax.value, e.max), e.min, e.max);
      if (which === 'min' && minV > maxV) minV = maxV;
      if (which === 'max' && maxV < minV) maxV = minV;
      e.rMin.value = minV; e.rMax.value = maxV;
      e.iMin.value = minV; e.iMax.value = maxV;
      positionFill(e, minV, maxV);
    }
    /* Typing in a text input (lenient — don't rewrite the field being edited). */
    function onPriceInputLive(price, which) {
      var e = priceEls(price);
      var raw = readInt(which === 'min' ? e.iMin.value : e.iMax.value, null);
      if (raw === null) return;
      var v = clamp(raw, e.min, e.max);
      if (which === 'min') e.rMin.value = v; else e.rMax.value = v;
      var minV = clamp(readInt(e.rMin.value, e.min), e.min, e.max);
      var maxV = clamp(readInt(e.rMax.value, e.max), e.min, e.max);
      positionFill(e, minV, maxV);
    }
    /* Blur / Enter — normalise, enforce order, rewrite both fields. */
    function onPriceInputCommit(price, which) {
      var e = priceEls(price);
      var minV = clamp(readInt(e.iMin.value, e.min), e.min, e.max);
      var maxV = clamp(readInt(e.iMax.value, e.max), e.min, e.max);
      if (which === 'min' && minV > maxV) maxV = minV;
      if (which === 'max' && maxV < minV) minV = maxV;
      e.iMin.value = minV; e.iMax.value = maxV;
      e.rMin.value = minV; e.rMax.value = maxV;
      positionFill(e, minV, maxV);
    }
    function initPrices() {
      root.querySelectorAll('[data-thulir-price]').forEach(function (p) {
        var e = priceEls(p);
        if (!e.rMin || !e.rMax) return;
        var minV = clamp(readInt(e.rMin.value, e.min), e.min, e.max);
        var maxV = clamp(readInt(e.rMax.value, e.max), e.min, e.max);
        positionFill(e, minV, maxV);
      });
    }

    /* Full re-render (sort / filter / pills) — swap the regions in place. */
    var SWAP = ['[data-thulir-count]', '[data-thulir-pills]', '[data-thulir-results]', '[data-thulir-filters]'];
    function applyUrl(url, push) {
      setLoading(true);
      return fetchDoc(url).then(function (doc) {
        SWAP.forEach(function (sel) {
          var from = doc.querySelector(sel);
          var to = root.querySelector(sel);
          if (from && to) to.innerHTML = from.innerHTML;
        });
        var nextSort = new URL(url, window.location.origin).searchParams.get('sort_by');
        if (sortSelect && nextSort) sortSelect.value = nextSort;
        if (push) window.history.pushState({ thulirFacet: true }, '', url);
        setLoading(false);
        initPrices();
        closeDrawer();
        observeLoadMore();
        window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      }).catch(function () { setLoading(false); });
    }

    /* Load more — append the next page's cards, refresh the button. */
    var loadingMore = false;
    function loadMore(url, btn) {
      if (loadingMore || !url) return;
      loadingMore = true;
      if (!btn) btn = root.querySelector('[data-thulir-loadmore-btn]');
      if (btn) btn.classList.add('is-loading');
      fetchDoc(url).then(function (doc) {
        var grid = root.querySelector('[data-thulir-grid]');
        var fresh = doc.querySelectorAll('[data-thulir-grid] > li');
        if (grid) fresh.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var newLoad = doc.querySelector('[data-thulir-loadmore]');
        var curLoad = root.querySelector('[data-thulir-loadmore]');
        if (curLoad) curLoad.innerHTML = newLoad ? newLoad.innerHTML : '';
        loadingMore = false;
        /* If the next page's button is already within the pre-load zone
           (e.g. a short viewport), keep filling until it scrolls out of view. */
        observeLoadMore();
      }).catch(function () {
        loadingMore = false;
        if (btn) btn.classList.remove('is-loading');
      });
    }

    /* Auto-load: when the load-more region nears the viewport, fetch the next
       page automatically (infinite scroll) so the visitor never has to click.
       The button stays in the DOM as a no-JS / unsupported-browser fallback and
       as a manual trigger. */
    var loadMoreObserver = null;
    function observeLoadMore() {
      if (typeof IntersectionObserver !== 'function') return;
      var btn = root.querySelector('[data-thulir-loadmore-btn]');
      if (!btn) return;
      if (!loadMoreObserver) {
        loadMoreObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var link = root.querySelector('[data-thulir-loadmore-btn]');
            if (link) loadMore(link.getAttribute('href'), link);
          });
        }, { rootMargin: '600px 0px' });
      }
      loadMoreObserver.observe(btn);
    }

    /* ---------- Drawer open / close (matches the other Thulir drawers) ---------- */
    function openDrawer() {
      if (!drawer || typeof drawer.showModal !== 'function') return;
      drawer.showModal();
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.classList.add('thulir-no-scroll');
    }
    function closeDrawer() {
      if (!drawer || !drawer.open) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('thulir-no-scroll');
      setTimeout(function () { try { drawer.close(); } catch (e) {} }, CLOSE_MS);
    }
    if (drawer) {
      drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    }

    /* ---------- Build the filtered URL from the drawer form ----------
       The form carries every active facet + the sort, plus (on search) the
       hidden q / type / options[prefix], so this works for both contexts. */
    function applyFilters() {
      var form = root.querySelector('[data-thulir-filter-form]');
      if (!form) return;
      var sp = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (key.indexOf('price') !== -1) return; // price handled below
        var v = String(value).trim();
        if (v === '') return;
        sp.append(key, v);
      });
      var price = form.querySelector('[data-thulir-price]');
      if (price) {
        var e = priceEls(price);
        var minV = clamp(readInt(e.iMin.value, e.min), e.min, e.max);
        var maxV = clamp(readInt(e.iMax.value, e.max), e.min, e.max);
        if (minV > maxV) { var t = minV; minV = maxV; maxV = t; }
        if (minV > e.min && e.iMin.name) sp.append(e.iMin.name, minV);
        if (maxV < e.max && e.iMax.name) sp.append(e.iMax.name, maxV);
      }
      if (sortSelect && sortSelect.value) sp.set('sort_by', sortSelect.value);
      var qs = sp.toString();
      applyUrl(baseUrl + (qs ? '?' + qs : ''), true);
    }

    /* ---------- Events (delegated, so swapped nodes keep working) ---------- */
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-thulir-filter-open]');
      if (open) { e.preventDefault(); openDrawer(); return; }

      var close = e.target.closest('[data-thulir-drawer-close]');
      if (close) { e.preventDefault(); closeDrawer(); return; }

      var apply = e.target.closest('[data-thulir-filter-apply]');
      if (apply) { e.preventDefault(); applyFilters(); return; }

      var more = e.target.closest('[data-thulir-loadmore-btn]');
      if (more) { e.preventDefault(); loadMore(more.getAttribute('href'), more); return; }

      var facet = e.target.closest('[data-thulir-facet-link]');
      if (facet && facet.getAttribute('href')) { e.preventDefault(); applyUrl(facet.getAttribute('href'), true); return; }
    });

    /* Price slider — range drag + live text typing (delegated). */
    root.addEventListener('input', function (e) {
      var range = e.target.closest('[data-thulir-price-range]');
      if (range) {
        onPriceRange(range.closest('[data-thulir-price]'), range.getAttribute('data-thulir-price-range'));
        return;
      }
      var input = e.target.closest('[data-thulir-price-input]');
      if (input) {
        onPriceInputLive(input.closest('[data-thulir-price]'), input.getAttribute('data-thulir-price-input'));
      }
    });
    /* Normalise price text inputs on blur / Enter. */
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-thulir-price-input]');
      if (input) onPriceInputCommit(input.closest('[data-thulir-price]'), input.getAttribute('data-thulir-price-input'));
    });
    root.addEventListener('keydown', function (e) {
      var input = e.target.closest('[data-thulir-price-input]');
      if (input && e.key === 'Enter') {
        e.preventDefault();
        onPriceInputCommit(input.closest('[data-thulir-price]'), input.getAttribute('data-thulir-price-input'));
      }
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSelect.value);
        u.searchParams.delete('page');
        applyUrl(u.pathname + u.search, true);
      });
      var sortForm = root.querySelector('[data-thulir-sort-form]');
      if (sortForm) sortForm.addEventListener('submit', function (e) { e.preventDefault(); });
    }

    grids.push({ root: root, applyUrl: applyUrl });
    initPrices();
    observeLoadMore();
  }

  function initAll() {
    document.querySelectorAll('[data-thulir-facet-grid]').forEach(initFacetGrid);
  }

  /* One popstate handler re-applies the current URL to every grid on the page. */
  window.addEventListener('popstate', function () {
    grids.forEach(function (g) { g.applyUrl(window.location.pathname + window.location.search, false); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* Re-init when the theme editor swaps a section in. */
  document.addEventListener('shopify:section:load', initAll);
})();
